// Campus photo for /colleges/harvey-mudd-college: CC BY 2.5, by The original uploader was Imagine at English Wikipedia ., from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHmc-dartmouth_entrance.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/harvey-mudd-college/; credited under the photo.
const photo = {
    "slug": "harvey-mudd-college",
    "alt": "A curved stone wall with the Harvey Mudd College name in front of a campus building on a sunny day",
    "src": "/colleges/harvey-mudd-college/campus-1600.webp",
    "srcSmall": "/colleges/harvey-mudd-college/campus-800.webp",
    "srcMid": "/colleges/harvey-mudd-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/harvey-mudd-college/og.jpg",
    "title": "Hmc-dartmouth entrance",
    "author": "Imagine at English Wikipedia",
    "license": "CC BY 2.5",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.5",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHmc-dartmouth_entrance.jpg",
    "read": "2026-10-01"
};

export default photo;
